export const getBasicConfigs = ({ t }) => {

    return [
        { id: "rolesAndPermissions", display: t("rolesAndPermissions"), entryUrl: "userRoles", pathKeywords: ["userRoles", "userRole"], isDefault: true },
        { id: "business", display: t("business"), entryUrl: "business", pathKeywords: ["business"] },
        { id: "locations", display: t("locations"), entryUrl: "locations", pathKeywords: ["locations", "location"] },
        { id: "countryAndRegions", display: t("countryAndRegions"), entryUrl: "countries", pathKeywords: ["countries", "country"] },
        { id: "shippingRates", display: t("shippingRates"), entryUrl: "shippingRates", pathKeywords: ["shippingRates", "shippingRate", "shippingRules", "shippingRule"] },
        { id: "auditTrails", display: t("auditTrails"), entryUrl: "auditTrails", pathKeywords: ["auditTrails", "auditTrail", "auditTrailTags", "auditTrailTag"] },
        { id: "taxRates", display: t("taxRates"), entryUrl: "taxRates", pathKeywords: ["taxRates", "taxRate"] },
        { id: "wallets", display: t("wallets"), entryUrl: "wallets", pathKeywords: ["wallets"] },
        { id: "schedulers", display: t("schedulers"), entryUrl: "schedulers", pathKeywords: ["schedulers"] },
    ]
}

export const getAdvancedConfigs = ({ t }) => {

    return [
        { id: "emailGateway", display: t("emailGateway"), entryUrl: "emailGateway", pathKeywords: ["emailGateway"] },
        { id: "whatsapp", display: t("WhatsApp"), entryUrl: "whatsapp", pathKeywords: ["whatsapp"] },
        { id: "sms", display: t("SMS"), entryUrl: "sms", pathKeywords: ["sms"] },
        { id: "customFields", display: t("customFields"), entryUrl: "customFields", pathKeywords: ["customFields", "customField"] },
        { id: "injectionProps", display: t("injectionProps"), entryUrl: "injectionProps", pathKeywords: ["injectionProps", "injectionProp"] },
        { id: "injectionFields", display: t("injectionFields"), entryUrl: "injectionFields", pathKeywords: ["injectionFields", "injectionField"] },
        { id: "userApiKeys", display: t("userApiKeys"), entryUrl: "userApiKeys", pathKeywords: ["userApiKeys", "userApiKey"] },
    ]
}